import {
    Col,
    Form,
    Input,
    Row,
    Tooltip
} from "antd";
import axios from "axios";
import { Notification } from "../../../../../components/notification/notification";
import { useEffect, useState } from "react";
import { authHeader } from "../../../../../utils/utils";
import './ReportFilter.scss';
import { UrlConstants } from "../../../../../utils/ApiConstants";
import { InfoCircleOutlined } from "@ant-design/icons";
import { GetRequest, PostRequest, replaceWithCurrentApiVersion } from "../../../../../utils/api";
import SearchFilterModule from "../../../../../components/searchModule/searchFilterModule";
import CustomLoader from "../../../../../components/loader";



const ReportFilter = (props: any) => {
    const [reportField, setReportField] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);

    let saveReportNameAs = "";

    // Ant Design Form instance
    const [form] = Form.useForm();

    useEffect(() => {

        if (props.bluePrintApi?.length > 0) {

            GetRequest(props.bluePrintApi).then((res) => {
                setReportField(res);
                setLoading(false);

            }).catch((err) => {
                console.error("Error fetching blueprint API data: ", err);
                setLoading(false);
            });
        }
    }, [props.bluePrintApi]);

    const refineSearchString = (searchText: string) => {
        // Match the pattern of the input string using regular expressions
        const regex = /&search=(.*)/;
        const match = searchText.match(regex);

        if (match && match[1]) {
            // If a match is found, return the extracted substring
            return match[1];
        } else {
            // If no match is found, return the original string
            return searchText;
        }
    }

    const onGenerateReportRequestSubmission = (searchText: string) => {
        saveReportNameAs = form.getFieldValue('saveReportNameAs');

        const data = {
            reportName: reportField.reportName,
            reportFilters: [],
            searchText: refineSearchString(searchText),
            saveReportNameAs: saveReportNameAs
        };

        const url = reportField.actions[0].createApi;


        PostRequest(url, data).then(res => {
            Notification(
                "success",
                "Request has been initiated"
            );
            props.onClose();
        }).catch((e) => {
            console.log(e.response.data, "error")
            Notification("info", e.response.data);
            props.onClose();
        })
    }

    return <>

        {loading ? <div className="my-5 text-center"><CustomLoader></CustomLoader></div> : <><Row>
            <Col span={18}>
                <Form form={form}>
                    <Form.Item
                        key={"saveReportNameAs"}
                        label={<div className="mx-3"><p>Save Report As </p> (optional)</div>}
                        name={"saveReportNameAs"}
                        rules={[{ required: false }]}
                    >
                        <Input className="w-100" maxLength={100} suffix={
                            <Tooltip title={`default value: ${(reportField ? reportField.reportName : "")}_<current timestamp>`}>
                                <InfoCircleOutlined rev={undefined} />
                            </Tooltip>
                        } />
                    </Form.Item>
                </Form>
            </Col>
        </Row>


            {reportField.searchForm ?
                <SearchFilterModule moduleName="Dynamic Reports" openMode={true} searchForm={reportField.searchForm} getSearchQuery={(queryString: string, searchFilter: any[]) => { onGenerateReportRequestSubmission(queryString) }} applyFilterLabel={"Generate Report"} hideClearFilter={true} ></SearchFilterModule>
                : <></>}

        </>
        }
    </>


}
export default ReportFilter;
